import * as moment from 'moment';

export function esDateFormatter(params): string {

  const dateFormat = 'DD/MM/yyyy';
  const result = moment(params.value).format(dateFormat);
  return result;

}
